import { Component } from 'react';
import ConfirmationModal from './Modal';
import { withTranslation } from 'react-i18next';

class ManageAccount extends Component {
    constructor() {
        super();
        this.accounts = window.accounts ?? [];
        this.accounts_exists = !!this.accounts.length;
        this.onToggleModal = this.onToggleModal.bind(this);

        this.state = {
            isOpenModal: false,
        };
    }

    onToggleModal() {
        this.setState({
            isOpenModal: !this.state.isOpenModal,
        });
    }

    render() {
        const { t } = this.props;

        return (
            <>
                <div className="settings-card settings-linked-accounts">
                    <div className="settings-linked-accounts-header">
                        {this.accounts_exists ? (
                            <div>
                                {t('settings.manage_account.select_an_account')}
                                <div className="settings-linked-accounts-header-sub">
                                    {t('settings.manage_account.select_an_account_subheader')}
                                </div>
                            </div>
                        ) : (
                            <div>
                                {t('settings.manage_account.link_google_account')}
                                <div className="settings-linked-accounts-header-sub">
                                    {t('settings.manage_account.link_google_account_subheader')}
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="settings-linked-accounts-body">
                        {this.accounts.length ? (
                            this.accounts?.map((item, i) => (
                                <div key={i} className="settings-linked-accounts-item">
                                    <div className="settings-linked-accounts-item-left">
                                        <img src={item.picture} />
                                        <div className="settings-linked-accounts-item-left-text-container">
                                            <div className="settings-linked-accounts-item-left-text">
                                                <div>
                                                    {item.given_name} {item.family_name}
                                                </div>
                                                {item.client_email && (
                                                    <div className="settings-linked-accounts-item-left-text-bottom">
                                                        {item.client_email}{' '}
                                                        <span className="email-address-container">
                                                            {t('settings.manage_account.added_by')}{' '}
                                                            <span className="email-address">
                                                                {item.added_by_user_username}
                                                            </span>
                                                        </span>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <a
                                        href={`/domains/link?account=${item.a_id}`}
                                        className="button button-filled button-primary px-16"
                                    >
                                        {t('settings.manage_account.select')}
                                    </a>
                                </div>
                            ))
                        ) : (
                            <div className="settings-linked-accounts-item-left-text">
                                {t('settings.manage_account.empty_message')}
                            </div>
                        )}
                        <div className="settings-linked-accounts-footer">
                            {this.accounts_exists ? (
                                <>
                                    {t('settings.manage_account.or')}{' '}
                                    <button onClick={this.onToggleModal}>
                                        {t('settings.manage_account.link_new_google_account')}
                                    </button>
                                </>
                            ) : (
                                <button onClick={this.onToggleModal}>Link Account</button>
                            )}
                        </div>
                    </div>
                </div>
                <ConfirmationModal isOpen={this.state.isOpenModal} onClose={this.onToggleModal} />
            </>
        );
    }
}

export default withTranslation()(ManageAccount);
